import React, { useState, useEffect } from 'react';

const DiagnosticTest = () => {
  const [status, setStatus] = useState('Loading...');
  const [apiStatus, setApiStatus] = useState('Not tested');
  const [cssStatus, setCssStatus] = useState('Checking...');

  useEffect(() => {
    setStatus('React component loaded successfully!');
    
    // Test basic API connectivity
    testApiConnectivity();
    
    // Test CSS loading
    testCssLoading();
  }, []);

  const testApiConnectivity = async () => {
    try {
      const response = await fetch('/account-management/ripolicy/policyholder/validate?test=true');
      if (response.ok) {
        setApiStatus('API endpoint reachable');
      } else {
        setApiStatus(`API endpoint returned: ${response.status} ${response.statusText}`);
      }
    } catch (error) {
      setApiStatus(`API error: ${error.message}`);
    }
  };

  const testCssLoading = () => {
    // Check if PrimeReact styles are loaded
    const testDiv = document.createElement('div');
    testDiv.className = 'p-button';
    testDiv.style.position = 'absolute';
    testDiv.style.left = '-9999px';
    document.body.appendChild(testDiv);
    
    const computedStyle = window.getComputedStyle(testDiv);
    const hasStyles = computedStyle.display !== 'inline' || computedStyle.padding !== '0px';
    
    document.body.removeChild(testDiv);
    
    if (hasStyles) {
      setCssStatus('✅ PrimeReact styles loaded');
    } else {
      setCssStatus('❌ PrimeReact styles NOT loaded');
    }
  };

  return (
    <div style={{ 
      padding: '20px', 
      margin: '20px', 
      border: '2px solid #007bff', 
      borderRadius: '8px',
      backgroundColor: '#f8f9fa'
    }}>
      <h2 style={{ color: '#007bff' }}>🔍 Registration App Diagnostic</h2>
      
      <div style={{ margin: '10px 0' }}>
        <strong>React Status:</strong> <span style={{ color: 'green' }}>{status}</span>
      </div>
      
      <div style={{ margin: '10px 0' }}>
        <strong>API Status:</strong> <span style={{ color: apiStatus.includes('error') ? 'red' : 'green' }}>{apiStatus}</span>
      </div>
      
      <div style={{ margin: '10px 0' }}>
        <strong>CSS Status:</strong> <span style={{ color: cssStatus.includes('NOT') ? 'red' : 'green' }}>{cssStatus}</span>
      </div>
      
      <div style={{ margin: '10px 0' }}>
        <strong>Current URL:</strong> {window.location.href}
      </div>
      
      <div style={{ margin: '10px 0' }}>
        <strong>Base URL:</strong> {window.location.origin}
      </div>
      
      <div style={{ margin: '10px 0' }}>
        <strong>Path:</strong> {window.location.pathname}
      </div>
      
      <div style={{ margin: '10px 0' }}>
        <strong>Environment:</strong> {process.env.NODE_ENV || 'development'}
      </div>

      <button 
        onClick={() => window.location.reload()} 
        style={{ 
          padding: '10px 20px', 
          backgroundColor: '#007bff', 
          color: 'white', 
          border: 'none', 
          borderRadius: '4px',
          cursor: 'pointer',
          margin: '10px 5px 0 0'
        }}
      >
        Reload Page
      </button>

      <button 
        onClick={testApiConnectivity}
        style={{ 
          padding: '10px 20px', 
          backgroundColor: '#28a745', 
          color: 'white', 
          border: 'none', 
          borderRadius: '4px',
          cursor: 'pointer',
          margin: '10px 5px 0 0'
        }}
      >
        Test API Again
      </button>

      <button 
        onClick={testCssLoading}
        style={{ 
          padding: '10px 20px', 
          backgroundColor: '#6f42c1', 
          color: 'white', 
          border: 'none', 
          borderRadius: '4px',
          cursor: 'pointer',
          margin: '10px 0 0 0'
        }}
      >
        Test CSS Again
      </button>
    </div>
  );
};

export default DiagnosticTest;